import React from "react";
import { useLang } from "@/context/LanguageContext";
import { AlertTriangle } from "lucide-react";

export function RiskBanner() {
  const { t } = useLang();
  return (
    <div className="border-y border-amber-500/20 bg-amber-500/5" data-testid="risk-disclaimer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 flex gap-4 items-start">
        <AlertTriangle className="h-5 w-5 text-amber-400 shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-semibold text-amber-300 mb-1">{t("risk_title")}</p>
          <p className="text-sm text-slate-400 leading-relaxed">{t("risk_text")}</p>
        </div>
      </div>
    </div>
  );
}
